/**
 * Events  metrics of the player
 */
export enum PlayerMetric {
  /** Starts in Loader.createPlayer() and ends once the promise of the created player has been resolved. */
  LoaderCreation = 'metric:LoaderCreation',

  /** Subset of LoaderCreation. Starts in Builder.build() and ends once the promise of the created player has been resolved. */
  BuilderCreation = 'metric:BuilderCreation',

  /** Subset of BuilderCreation. Starts in player/core createPlayer() and ends right before the created player is returned. */
  PlayerCreation = 'metric:PlayerCreation',

  /** Starts in player.loadMedia() and ends when the MediaLoadedEvent has been fired. */
  MediaLoad = 'metric:MediaLoad',

  /** Starts in player.play() and ends when the first TimeChangedEvent has been fired. */
  MediaPlay = 'metric:MediaPlay',

  /** Starts after the AdSlotCompleted event and ends when the first content TimeChangedEvent has been fired. */
  MediaPlayAfterAd = 'metric:MediaPlayAfterAd',

  /** Starts in the initAdSlot event callback of the advertising plugin and ends when the initialization by smartclip finished. */
  AdSlotLoad = 'metric:AdSlotLoad',
}
